import React from 'react';
import { Box, Typography } from '@mui/material';
import ScrollFadeWrapper, {
  ScrollFadeSection,
} from '../../ScrollFadeWrapper/ScrollFadeWrapper';
import Image from '../../Image/Image';

const SECTION_STEPS_VECTOR_URL =
  'https://assets.askhippo.co.za/Vectors/SectionStepsVector.svg';

const TITLE_TO_SUBTITLE_GAP = 16;
const CARD_WIDTH = 389;
const CARD_HEIGHT = 384;

const SectionStepsIconComponent = ({ data }) => {
  if (!data) return null;

  const { title, subtitle, steps = [] } = data;

  return (
    <ScrollFadeSection
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: '1010px',
            backgroundColor: '#C7CA00',
            borderRadius: '34px',
            px: '32px',
            pt: '32px',
            pb: '40px',
            overflow: 'visible',
          }}
        >
          <ScrollFadeWrapper variant="text">
            <Typography
              component="h3"
              sx={{
                mt: `${TITLE_TO_SUBTITLE_GAP}px`,
                fontFamily: 'Inter, sans-serif',
                fontWeight: 700,
                fontSize: '3rem',
                lineHeight: '3.25rem',
                letterSpacing: '-0.03em',
                textAlign: 'center',
                color: '#162F3B',
                whiteSpace: 'pre-line',
              }}
            >
              {title}
            </Typography>
          </ScrollFadeWrapper>

          {subtitle && (
            <ScrollFadeWrapper variant="text" delay={0.2}>
              <Typography
                component="p"
                sx={{
                  mt: 1.5,
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 400,
                  fontSize: '1.5rem',
                  lineHeight: '1.75rem',
                  letterSpacing: '-0.03em',
                  textAlign: 'center',
                  color: '#162F3B',
                  maxWidth: 780,
                  mx: 'auto',
                  whiteSpace: 'pre-line',
                }}
              >
                {subtitle}
              </Typography>
            </ScrollFadeWrapper>
          )}

          <Box
            sx={{
              mt: '40px',
              position: 'relative',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 'max-content',
              display: 'flex',
              gap: '24px',
            }}
          >
            {steps.map((step, index) => (
              <ScrollFadeWrapper key={index} delay={0.4 + index * 0.15}>
                <Box
                  sx={{
                    position: 'relative',
                    width: `${CARD_WIDTH}px`,
                    height: `${CARD_HEIGHT}px`,
                    backgroundColor: '#FFFFFF',
                    borderRadius: '32px',
                    pt: '120px',
                    pr: '64px',
                    pb: '64px',
                    pl: '64px',
                    boxSizing: 'border-box',
                    boxShadow:
                      '0px 1px 2px rgba(162,172,177,0.20), 0px 12px 24px -4px rgba(22,47,59,0.12)',
                  }}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '-20px',
                      left: '32px',
                      width: '96px',
                      height: '96px',
                      zIndex: 2,
                    }}
                  >
                    <Image
                      width={96}
                      height={96}
                      src={SECTION_STEPS_VECTOR_URL}
                      alt="Steps process graphic"
                      sx={{ width: '100%', height: '100%' }}
                    />

                    <Image
                      width={48}
                      height={48}
                      src={step.icon}
                      alt={step.imgAltTag || step.heading}
                      title={step.imageAltTitle || step.heading}
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '48px',
                        height: '48px',
                        objectFit: 'contain',
                        filter: 'brightness(0) invert(1)',
                      }}
                    />
                  </Box>

                  <Typography
                    component="h3"
                    sx={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 700,
                      fontSize: '1.625rem',
                      lineHeight: '1.875rem',
                      color: '#162F3B',
                      mb: '32px',
                      whiteSpace: 'pre-line',
                    }}
                  >
                    {step.heading}
                  </Typography>

                  <Typography
                    component="p"
                    sx={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 400,
                      fontSize: '1rem',
                      lineHeight: '1.5rem',
                      letterSpacing: '-0.002em',
                      color: '#162F3B',
                      whiteSpace: 'pre-line',
                    }}
                  >
                    {step.text}
                  </Typography>
                </Box>
              </ScrollFadeWrapper>
            ))}
          </Box>
        </Box>
      </Box>
    </ScrollFadeSection>
  );
};

export default SectionStepsIconComponent;
